// downloadDataTnos

import axios from "axios";
import { downloadDataTnos } from "../enums/endpoints";
import * as XLSX from "xlsx";

export const downloadTnosData = (
  {
    clientFormData,
    selectedWareHouseRows,
    setClientFormData,
    setSelectedRows,
    setWareHouseStatusRows,
    selectedWareHouseRowsWithPage,
    setSelectedWareHouseRowsWithPage,
  }: {
    clientFormData: {
      clientOrderNum: string;
      clientName: string;
      address: string;
      notes: string;
    };
    selectedWareHouseRows: any;
    setClientFormData: React.Dispatch<
      React.SetStateAction<{
        clientOrderNum: string;
        clientName: string;
        address: string;
        notes: string;
      }>
    >;
    setSelectedRows: React.Dispatch<any>;
    setWareHouseStatusRows: React.Dispatch<any>;
    selectedWareHouseRowsWithPage: any;
    setSelectedWareHouseRowsWithPage: any;
  },
  successWindow: any,
  setSuccessWindow: any,
  failedWindow: any,
  setFailedWindow: any,
  updatedTableData: any,
  setResultCount: any
) => {
  const token = localStorage.getItem("dm_access_token");
  const selectedChargers = selectedWareHouseRowsWithPage
    ?.map((item: any) => {
      return Object.values(item);
    })
    .reduce((accumulator: any, currentArray: any) => {
      return accumulator.concat(currentArray);
    }, [])
    .reduce((accumulator: any, currentArray: any) => {
      return accumulator.concat(currentArray);
    }, [])
    ?.map((item: any) => {
      return item?.chargerId;
    });

  const payload = {
    tenenantOrderId: clientFormData?.clientOrderNum,
    tenantName: clientFormData?.clientName,
    address: clientFormData?.address,
    notes: clientFormData?.notes,
    chargerIds: [...selectedChargers],
  };

  return axios
    .post(downloadDataTnos, payload, {
      responseType: "arraybuffer", // Important: Tell Axios to treat the response as binary data
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(async (response: any) => {
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const contentDisposition = response.headers["content-disposition"];
      let filename = "";

      if (contentDisposition) {
        const matches = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        );
        if (matches && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
        }
      }

      const workbook = XLSX.read(await blob.arrayBuffer(), {
        type: "array",
      });

      XLSX.writeFile(workbook, filename);
      setClientFormData({
        clientOrderNum: "",
        clientName: "",
        address: "",
        notes: "",
      });

      if (!response?.isError) {
        setSuccessWindow({
          ...successWindow,
          status: true,
          message: "Generated Vendor ONos",
        });
      } else {
        setFailedWindow({
          ...failedWindow,
          status: true,
          message: "Could not generate Vendor Onos",
        });
      }

      setSelectedRows([]);
      setWareHouseStatusRows([]);
      setSelectedWareHouseRowsWithPage([]);
    })
    .catch((error) => {
      const result = JSON.parse(
        new TextDecoder().decode(error?.response?.data as ArrayBuffer)
      );
      setFailedWindow({
        ...failedWindow,
        status: true,
        message: result?.Message,
      });
      setSelectedRows([]);
      setWareHouseStatusRows([]);
      setSelectedWareHouseRowsWithPage([]);
      // return error;
    });
};
